import { schedule } from '@/utils';

export const storageKey = 'mopDeploy';

export function setStorage(key, updateState, storageType = 'localStorage') {
	const storage = window[storageType];
	try {
		schedule(() => {
			const newState = JSON.parse(storage.getItem(storageKey)) ?? {};
			if (newState[key] && typeof newState[key] === 'object') {
				Object.assign(newState[key], updateState);
			} else {
				newState[key] = updateState;
			}
			storage.setItem(storageKey, JSON.stringify(newState));
		});
	} catch (e) {}
}

export function getStorage(key, storageType = 'localStorage') {
	const storage = window[storageType];
	try {
		return JSON.parse(storage.getItem(storageKey))[key];
	} catch (e) {
		return {};
	}
}

export function setSessionStorage(key, updateState = {}) {
	updateState.time = new Date().getTime() + 60000 * 10;
	setStorage(key, updateState, 'sessionStorage');
}

export function getSessionStorage(key) {
	const { time, ...data } = getStorage(key, 'sessionStorage') ?? {};
	const isExpired = Date.now() > Number(time);

	if (isExpired) {
		return {};
	}

	return data;
}

export function clearStorage() {
	try {
		localStorage.removeItem(storageKey);
	} catch (e) {}
}
